export enum AllowedStatusSprinklrChat {
  OPERATIONAL = 'OPERATIONAL',
  ASSISTED_OPERATIONAL = 'ASSISTED_OPERATIONAL',
}
